export class SearchResultsDto {
}
//# sourceMappingURL=search-results.dto.js.map